export const FACT_CHART = 'FACT_CHART';
export const FACT_CHART_MODAL_OPEN = 'FACT_CHART_MODAL_OPEN';
export const FACT_CHART_MODAL_CLOSE = 'FACT_CHART_MODAL_CLOSE';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/FactCharts/FactChartConstants.js